/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module);
}
/* jshint ignore:end */

define('common/apiVersion',[], function() {
	'use strict';
	return {
		apiVersion: 'v1.9'
	};
});
